var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondTronDaoAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 133,
    viewBox: "0 0 134 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tron dao"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_18484)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0566,
    cy: 66.5,
    rx: 27.0566,
    ry: 26.5,
    fill: "#FF4747",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_18484)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0566,
    cy: 66.5,
    rx: 27.0566,
    ry: 26.5,
    fill: "#FF4747",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter2_f_1877_18484)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0566,
    cy: 66.5,
    rx: 27.0566,
    ry: 26.5,
    fill: "#FF4747",
    fillOpacity: 0.78
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.1983 89.6514C65.0643 89.3898 64.9504 89.2076 64.8696 89.011C63.7103 86.1523 62.5541 83.2919 61.4009 80.4296C59.1361 74.8349 56.8714 69.2427 54.6066 63.6528C52.6663 58.8519 50.7278 54.0509 48.7911 49.25C48.777 49.2232 48.7647 49.1955 48.7544 49.167C48.6846 48.9037 48.6167 48.6385 48.5469 48.3733C48.8146 48.3603 49.0829 48.3681 49.3493 48.3967C51.8614 48.8477 54.3679 49.315 56.8781 49.7696C59.6876 50.2765 62.5008 50.7708 65.3103 51.2777C67.1301 51.606 68.9443 51.9559 70.7623 52.2843C72.8813 52.6703 75.0022 53.0419 77.1213 53.4226C78.0835 53.603 79.0458 53.7707 80.0025 53.9637C80.1929 54.0101 80.3676 54.1047 80.5093 54.238C83.0874 56.6336 85.6625 59.0323 88.2345 61.4339C88.4733 61.6576 88.4788 61.8236 88.2657 62.0779C82.8218 68.5902 77.3815 75.1055 71.9448 81.6238C69.8404 84.1493 67.7312 86.6653 65.617 89.1716C65.516 89.305 65.3966 89.4349 65.1983 89.6514ZM64.9633 83.0688L65.0918 83.0381C65.1241 82.9594 65.1487 82.8778 65.1653 82.7946C65.464 80.3953 65.7621 77.996 66.0595 75.5968C66.4745 72.1981 66.8895 68.8013 67.2825 65.4008C67.2852 65.2881 67.2644 65.1761 67.2215 65.0715C67.1785 64.967 67.1143 64.8722 67.0328 64.7929C66.4819 64.295 65.8924 63.8404 65.3158 63.3696C61.3617 60.1489 57.407 56.9301 53.4516 53.713C53.3522 53.6399 53.2486 53.5724 53.1413 53.511L53.0366 53.5903L64.9633 83.0688ZM84.0349 63.5662C83.8393 63.5526 83.643 63.5526 83.4473 63.5662C81.9434 63.8314 80.4413 64.1074 78.9374 64.3744L73.3882 65.3593C72.2754 65.556 71.1626 65.7598 70.048 65.951C69.7174 66.007 69.5338 66.1585 69.4971 66.503C69.4548 66.9811 69.3832 67.4573 69.3245 67.9354C69.0588 70.0821 68.7919 72.2282 68.5238 74.3737C68.23 76.7597 67.9374 79.1452 67.6461 81.53C67.58 82.0712 67.5304 82.6124 67.4735 83.1536L67.6039 83.2113L84.0349 63.5662ZM77.1048 55.912L76.9965 55.71L54.8655 51.7088L54.7719 51.8495C54.9023 51.9451 55.0345 52.0299 55.1612 52.14C56.2923 53.0564 57.4229 53.9752 58.5528 54.8964C61.6745 57.4382 64.7962 59.9745 67.894 62.5343C68.298 62.8681 68.5532 62.8392 68.937 62.5199C71.4968 60.3985 74.0786 58.2987 76.6494 56.1934C76.7946 56.0897 76.9467 55.9957 77.1048 55.912ZM84.3912 61.0894C84.3376 60.9933 84.2761 60.9016 84.2076 60.8152C82.8046 59.5019 81.3944 58.1904 79.9933 56.8735C79.7784 56.6733 79.626 56.7094 79.4093 56.888C77.417 58.5242 75.4154 60.1495 73.4194 61.7821C72.8391 62.2565 72.2662 62.7418 71.6896 63.2253L71.7428 63.3389L84.3912 61.0894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_18484",
    x: 0.700001,
    y: 0.700001,
    width: 132.713,
    height: 131.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18484"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_18484",
    x: 0.700001,
    y: 0.700001,
    width: 132.713,
    height: 131.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18484"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_18484",
    x: 0.700001,
    y: 0.700001,
    width: 132.713,
    height: 131.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondTronDaoAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SecondTronDaoAdaptiveIcon.3aa9884df3ec93dcb15d829b1e333072.svg";
export { ForwardRef as ReactComponent };